import PageAddListing1 from "containers/AddListingFlows/PageAddListing/PageAddListing1";
import PageAddListing2 from "containers/AddListingFlows/PageAddListing/PageAddListing2";
import PageAddListing3 from "containers/AddListingFlows/PageAddListing/PageAddListing3";
import PageAddListing4 from "containers/AddListingFlows/PageAddListing/PageAddListing4";
import PageAddListing5 from "containers/AddListingFlows/PageAddListing/PageAddListing5";
import PageAddListing6 from "containers/AddListingFlows/PageAddListing/PageAddListing6";
import PageAddListing7 from "containers/AddListingFlows/PageAddListing/PageAddListing7";
import PageAddListing8 from "containers/AddListingFlows/PageAddListing/PageAddListing8";
import PageAddListing9 from "containers/AddListingFlows/PageAddListing/PageAddListing9";
import PageAddListing10 from "containers/AddListingFlows/PageAddListing/PageAddListing10";
import { PageAddListingContextProvider } from "application/contexts/AddItemContext/PageAddListingContext";
import { Page } from "navigation/types";
import { Route, Routes } from "react-router-dom";
import { StockNumericType } from "data/enums";
import PageAddListingBorgoIntro from "containers/AddListingFlows/InFlowBorgoCreation/PageAddListingBorgoIntro";
import PageAddListingBorgo from "containers/AddListingFlows/InFlowBorgoCreation/PageAddListingBorgo";

const AddListingPages: Page[] = [
  { path: "/add-listing-1", component: PageAddListing1 },
  { path: "/add-listing-2", component: PageAddListing2 },
  { path: "/add-listing-3", component: PageAddListing3 },
  { path: "/add-listing-4", component: PageAddListing4 },
  { path: "/add-listing-5", component: PageAddListing5 },
  { path: "/add-listing-6", component: PageAddListing6 },
  { path: "/add-listing-7", component: PageAddListing7 },
  { path: "/add-listing-8", component: PageAddListing8 },
  { path: "/add-listing-9", component: PageAddListing9 },
  { path: "/add-listing-10", component: PageAddListing10 },
  { path: "/add-listing-borgo-intro", component: () => <PageAddListingBorgoIntro 
      indexPage="03a" backHref="/host/new-property/add-listing-2" nextHref="/host/new-property/add-listing-borgo"
    />
  },
  { path: "/add-listing-borgo", component: () => <PageAddListingBorgo
      indexPage="03b" backHref="/host/new-property/add-listing-borgo-intro" nextHref="/host/new-property/add-listing-4" sourceFlow={StockNumericType.STAY}
    /> 
  }
]

const AddListingPagesRouter = () => {
  return (
    <PageAddListingContextProvider>
      <Routes>
        {AddListingPages.map(({ component, path }) => {
          const Component = component;
          return <Route key={path} element={<Component />} path={path} />;
        })}
      </Routes>
    </PageAddListingContextProvider>

  )
}

export default AddListingPagesRouter;